import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ZendeskController = () => {
	const location = useLocation();

	useEffect(() => {
		const isOnboarding = location.pathname.startsWith('/onboarding');
		if (window.zE) {
			window.zE('messenger', isOnboarding ? 'hide' : 'show');
		}
	}, [location.pathname]);

	return null;
};

export default ZendeskController;
